import { Authenticator } from '@aws-amplify/ui-react';
import { useEffect } from 'react';
import { Navigate } from 'react-router';

import { TokenService } from '@/services/auth/tokenService';

import '@aws-amplify/ui-react/styles.css';

export const CognitoLoginController = () => {
  useEffect(() => {
    const tokenService = TokenService.getInstance();
    const tokens = tokenService.getStoredTokens();

    // If tokens exist but are expired, attempt to refresh them
    if (tokens && tokenService.isTokenExpired()) {
      tokenService
        .refreshTokens()
        .then((refreshedTokens) => {
          if (refreshedTokens) {
            console.log('Tokens refreshed successfully on login');
          }
        })
        .catch((error) => {
          console.error('Failed to refresh token on login:', error);
        });
    }
  }, []);

  return (
    <Authenticator hideSignUp socialProviders={['google']}>
      <Navigate to="/" />
    </Authenticator>
  );
};
